import React, { useState } from "react";
import { Plus } from "lucide-react";
import SpillTheTeaModal from "components/Posts/SpillTheTeaModal";
import { Impact, Action, Solution, Issue, Comment } from "util/constants";

interface Props {
  className?: string;
  initialIssue?: Issue | null;
  title?: string;
  buttonText?: string | null;
  onImpactAdded?: (item: Impact | Comment) => void;
  onSolutionAdded?: (solution: Solution) => void;
  onActionAdded?: (action: Action) => void;
}

const PostCreateIconButton: React.FC<Props> = ({
  className = "",
  initialIssue = null,
  title = "Create post",
  buttonText = null,
  onImpactAdded,
  onSolutionAdded,
  onActionAdded,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <button
        type="button"
        className={`rounded-full p-2 justify-center flex items-center text-sm eoe-icon text-eoe-gray dark:text-eoe-dark-text font-semibold hover:bg-indigo-600 hover:text-white cursor-pointer transition-colors ${className}`}
        onClick={() => setOpen(true)}
        title={title}
        aria-label={title}
      >
        {buttonText ? <span className="flex items-center"><Plus className="size-5" /> {buttonText}</span> : <Plus className="size-5" />}
      </button>
      {open && (
        <SpillTheTeaModal
          open={open}
          onClose={() => setOpen(false)}
          initialSelectedIssue={initialIssue}
          onImpactAdded={onImpactAdded}
          onSolutionAdded={onSolutionAdded}
          onActionAdded={onActionAdded}
        />
      )}
    </>
  );
};

export default PostCreateIconButton;


